import {
    IDeviceInformation, IDeviceItemGrouping, IDeviceItemVisitor, IDeviceNode,
    IDynamicControlsSharedState
} from '../shared/models/device';

import { DeviceService } from '../shared/services/device.service';
import { DeviceCategory } from '../shared/models/device-category';
import { ElementTypes } from '../shared/models/models';

/**
 * Visits a node representing a Device Category.  When visited, the
 * category is created and added to the current grouping.
 */
export class DeviceCategoryVisitor implements IDeviceItemVisitor {
    public service: DeviceService;
    public currentGrouping: IDeviceItemGrouping;

    public init(
        rootNode: IDeviceNode,
        device: IDeviceInformation,
        sharedState: IDynamicControlsSharedState
    ) {
        // purposely empty
    }

    public canVisit(owningObject: IDeviceNode, propName: string, propValue: IDeviceNode): boolean {
        return this.isDeviceCategories(owningObject) && this.isDeviceCategory(propValue);
    }

    public visit(owningObject: IDeviceNode, propName: string, propValue: IDeviceNode): IDeviceItemGrouping {
        let category = new DeviceCategory(propValue);

        propValue.$isContainer = true;

        this.currentGrouping.$selectedCategory = 0;
        this.currentGrouping.$categories.push(category);

        return category; // Make current grouping.
    }

    private isDeviceCategories(owningObject: IDeviceNode) {
        return owningObject.elementType === ElementTypes.Root;
    }

    private isDeviceCategory(propValue: IDeviceNode) {
        return propValue.elementType === ElementTypes.DeviceCategory;
    }
}
